<div class="card" fxLayout="row" fxLayoutAlign="space-between center">
  <div
    class="p-1"
    fxFlex
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="space-between center"
  >
    <div fxFlex fxLayout="column">
      <div class="title">{{ application.credentialName }}</div>
      <div class="subtitle">{{ application.name }}</div>
    </div>

    <div class="card-text">
      <span
        ><span class="title">Started</span>
        {{
          application.credentialApplicationStartDate?.toLocaleString()
            | localDate: 'MMM DD, YYYY'
        }}</span
      ><br />
      <span
        ><span class="title">Deadline</span>
        {{
          application.credentialApplicationEndDate?.toLocaleString()
            | localDate: 'MMM DD, YYYY'
        }}</span
      >
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <span class="rounded">
        <svg width="15" height="10">
          <circle
            [ngClass]="CredentialStatusLabelColor[application.getStatusColor()]"
            class="status-dot"
            cx="5"
            cy="5"
            r="4"
            stroke-width="0"
          />
        </svg>
        <span class="title">{{ application.getStatusText() }}</span></span
      >
    </div>
  </div>
</div>
